import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { login as _login, logout as _logout, getInfo as _getInfo, getInformationReminder } from "@/api/user";
import { getConversationList } from "@/api/customerservice";
import { getToken, setToken, setUserName, removeToken, setSchoolId, setSchool, removeSchoolId, setRoles, getRoles, removeRoles, setSubAccountNo, removeSubAccountNo, setIsCheckOpen, removeIsCheckOpen } from "@/utils/auth";
import router, { resetRouter } from "@/router";

//设置管理员默认头像
function setAdminHeadimg(roles) {
  // console.log(roles)
  var isDev = process.env.BASE_URL == "/wxaward/dev/";
  //console.log(process.env)
  if (roles == "superadmin" || roles == "superadmin_03") {
    return require(isDev ? "@/assets/workben/admin_headimg_super0.png" : "@/assets/workben/admin_headimg_super.png");
  } else if (roles == "province" || roles == "city" || roles == "district" || roles == "province_03" || roles == "city_03" || roles == "district_03") {
    return require("@/assets/workben/admin_headimg_gov.png");
  } else if (roles == "screen" || roles == "screen_03") {
    return require("@/assets/workben/admin_headimg_screen.png");
  } else if (roles == "schooladmin") {
    return require("@/assets/workben/admin_headimg_school.png");
  } else if (roles == "schooldoctor") {
    return require("@/assets/workben/admin_headimg_schooldoctor.png");
  } else if (roles == "schoolclazz" || roles == "schoolgrade") {
    return require("@/assets/workben/admin_headimg_garde&clazz.png");
  }
}
var state = {
  token: getToken(),
  is_first: false,
  //判断是否首次登陆
  school_id: 0,
  school: "",
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  area_code: 0,
  area_name: "",
  whole_name: [],
  area_level: 0,
  logintime: "",
  msgnum: 0,
  customernum: 0,
  //未回复客服信息
  telphone: "",
  ischildno: "",
  username: "",
  address: "",
  grade: "",
  clazz: "",
  iscustomreceipt: "",
  issecret: "",
  isconfig: 0,
  currentInfo: {},
  // 判断是否连续90天密码未变化
  is_password_old: 0,
  is_checkdata: 0,
  grade_code: "",
  ischeckopen: "",
  //判断是否为江苏账号
  isJs: false,
  //判断是否为安徽账号
  isAnhui: false
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_IS_FIRST: function SET_IS_FIRST(state, is_first) {
    state.is_first = is_first;
  },
  SET_SCHOOL_ID: function SET_SCHOOL_ID(state, school_id) {
    state.school_id = school_id;
  },
  SET_GRADE: function SET_GRADE(state, grade) {
    state.grade = grade;
  },
  SET_CLAZZ: function SET_CLAZZ(state, clazz) {
    state.clazz = clazz;
  },
  SET_SCHOOL: function SET_SCHOOL(state, school) {
    state.school = school;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_MSGNUM: function SET_MSGNUM(state, msgnum) {
    state.msgnum = msgnum;
  },
  SET_CUSTOMERNUM: function SET_CUSTOMERNUM(state, customernum) {
    state.customernum = customernum;
  },
  SET_TELPHONE: function SET_TELPHONE(state, telphone) {
    state.telphone = telphone;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_AREA_CODE: function SET_AREA_CODE(state, area_code) {
    state.area_code = area_code;
  },
  SET_AREA_NAME: function SET_AREA_NAME(state, area_name) {
    state.area_name = area_name;
  },
  SET_WHOLE_NAME: function SET_WHOLE_NAME(state, whole_name) {
    state.whole_name = whole_name;
  },
  SET_AREA_LEVEL: function SET_AREA_LEVEL(state, area_level) {
    state.area_level = area_level;
  },
  SET_LOGINTIME: function SET_LOGINTIME(state, logintime) {
    state.logintime = logintime;
  },
  SET_ISCHILDNO: function SET_ISCHILDNO(state, ischildno) {
    state.ischildno = ischildno;
  },
  SET_USERNAME: function SET_USERNAME(state, username) {
    state.username = username;
  },
  SET_ADDRESS: function SET_ADDRESS(state, address) {
    state.address = address;
  },
  SET_ISCUSTOMRECEIPT: function SET_ISCUSTOMRECEIPT(state, iscustomreceipt) {
    state.iscustomreceipt = iscustomreceipt;
  },
  SET_ISSECRET: function SET_ISSECRET(state, issecret) {
    state.issecret = issecret;
  },
  SET_ISCONFIG: function SET_ISCONFIG(state, isconfig) {
    state.isconfig = isconfig;
  },
  SET_CURRENT_INFO: function SET_CURRENT_INFO(state, currentInfo) {
    state.currentInfo = currentInfo;
  },
  SET_IS_PASSWORD_OLD: function SET_IS_PASSWORD_OLD(state, is_password_old) {
    state.is_password_old = is_password_old;
  },
  SET_IS_CHECKDATA: function SET_IS_CHECKDATA(state, is_checkdata) {
    state.is_checkdata = is_checkdata;
  },
  SET_GRADE_CODE: function SET_GRADE_CODE(state, grade_code) {
    state.grade_code = grade_code;
  },
  SET_IS_CHECKOPEN: function SET_IS_CHECKOPEN(state, ischeckopen) {
    state.ischeckopen = ischeckopen;
  },
  SET_IS_JS: function SET_IS_JS(state, isJs) {
    state.isJs = isJs;
  },
  SET_IS_ANHUI: function SET_IS_ANHUI(state, isAnhui) {
    state.isAnhui = isAnhui;
  },
  SET_USER_NAME: function SET_USER_NAME(state, user_name) {
    state.user_name = user_name;
  },
  SET_NICKNAME: function SET_NICKNAME(state, nickname) {
    state.nickname = nickname;
  },
  SET_REMARK: function SET_REMARK(state, remark) {
    state.remark = remark;
  },
  SET_DH_ADDRESS: function SET_DH_ADDRESS(state, dh_address) {
    state.dh_address = dh_address;
  },
  SET_ISJY: function SET_ISJY(state, isJy) {
    state.isJy = isJy;
  },
  SET_LEVELSTR: function SET_LEVELSTR(state, levelstr) {
    state.levelstr = levelstr;
  }
};
var actions = {
  // 账号登录
  login: function login(_ref, userInfo) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    setUserName(userInfo.username);
    // const { username, pwd, school_id, school, role } = userInfo
    return new Promise(function (resolve, reject) {
      // login({ username: username.trim(), pwd: pwd, school_id: school_id, school: school }).then(response => {
      _login(userInfo).then(function (response) {
        if (response.error == "-1") {
          var data = response.data;
          if (data.is_first == 0) {
            commit("SET_IS_FIRST", true);
          } else {
            commit("SET_IS_FIRST", false);
          }
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          // if (process.env.VUE_APP_MODE != 'xm' && process.env.VUE_APP_MODE != 'hb') {
          //   if (this.$socket.disconnect) {
          //     this.$socket.open()
          //     this.$socket.emit("setImpArchivesResult", data.token)
          //   }
          //   console.log(this.$socket)
          //   localStorage.setItem("socketid", this.$socket.id)
          // }
          resolve();
        } else {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 使用TOKEN直接登录（扫码登录）
  loginByToken: function loginByToken(_ref2, token) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      commit("SET_TOKEN", token);
      setToken(token);
      resolve();
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        if (!response.data) {
          reject("验证失败，请重新登陆");
        }

        // 保存当前用户信息
        commit("SET_CURRENT_INFO", _objectSpread({}, response.data));

        // const { rtnData } = response

        // 角色权限设置
        var _roles = ["hospital"];
        if (response.data.domain == 0) {
          _roles = ["school"];
        }
        if (response.data.role == 1) {
          _roles.push("sysadmin");
        }

        // if (response.data.username == 'jyb'||response.data.username == 'bjtest') {
        //   // _roles.push('demo')
        //   // _roles = ['demo']
        //   _roles = ['province']// 省级管理员
        //   _roles = ['city']// 市级管理员
        //   _roles = ['district']// 区级管理员
        //   _roles = ['screen']// 筛查管理员
        //   _roles = ['schooladmin']// 学校管理员
        //   _roles = ['demo', 'superadmin', 'screen', 'schooladmin']// 超级管理员
        // }else{

        // }

        if (response.data.user_roles == "schooladmin") {
          if (response.data.school_role == 1) {
            _roles = ["schooldoctor"];
          } else if (response.data.school_role == 2) {
            _roles = ["schoolgrade"];
          } else {
            _roles = ["schooladmin"];
          }
        } else {
          _roles = [response.data.user_roles];
        }

        //默认筛查机构（兼容老数据）
        if (response.data.user_roles == "") {
          _roles = ["screen"];
        }

        // _roles = ["fifteenadmin"];
        setUserName(response.data.user_name);
        var wholename = response.data.whole_name.split("，");
        //判断是否为江苏账号
        var is_js = String(response.data.area_code).length >= 2 && String(response.data.area_code).slice(0, 2) == 32;
        //判断是否为安徽的帐号
        var is_anhui = String(response.data.area_code).length >= 2 && String(response.data.area_code).slice(0, 2) == 34;
        var is_Jy = response.data.tenant_id == '8607'; //教育云账号
        var data = {
          roles: _roles,
          school_id: response.data.school_id,
          grade: response.data.grade,
          clazz: response.data.clazz,
          school: response.data.school,
          introduction: "I am a super administrator",
          avatar: setAdminHeadimg(_roles),
          name: response.data.name,
          telphone: response.data.telphone,
          logintime: response.data.logintime,
          area_code: Number(response.data.area_code),
          area_name: response.data.area_name,
          area_level: response.data.area_level,
          whole_name: wholename,
          username: response.data.username,
          ischildno: response.data.is_sonAccount,
          address: response.data.dh_address,
          issecret: response.data.issecret,
          iscustomreceipt: response.data.iscustomreceipt,
          isconfig: response.data.isconfig,
          is_password_old: response.data.is_password_old,
          is_checkdata: response.data.is_checkdata,
          grade_code: response.data.grade_code,
          ischeckopen: response.data.ischeckopen,
          isJs: is_js,
          isAnhui: is_anhui,
          user_name: response.data.user_name,
          nickname: response.data.nickname,
          remark: response.data.remark,
          dh_address: response.data.dh_address,
          isJy: is_Jy,
          levelstr: response.data.levelstr
        };
        if (!data) {
          reject("验证失败，请重新登陆");
        }
        var roles = data.roles,
          name = data.name,
          telphone = data.telphone,
          username = data.username,
          avatar = data.avatar,
          introduction = data.introduction,
          school_id = data.school_id,
          grade = data.grade,
          clazz = data.clazz,
          school = data.school,
          area_code = data.area_code,
          area_name = data.area_name,
          area_level = data.area_level,
          whole_name = data.whole_name,
          logintime = data.logintime,
          ischildno = data.ischildno,
          address = data.address,
          iscustomreceipt = data.iscustomreceipt,
          issecret = data.issecret,
          isconfig = data.isconfig,
          is_password_old = data.is_password_old,
          is_checkdata = data.is_checkdata,
          grade_code = data.grade_code,
          ischeckopen = data.ischeckopen,
          isJs = data.isJs,
          isAnhui = data.isAnhui,
          user_name = data.user_name,
          nickname = data.nickname,
          remark = data.remark,
          dh_address = data.dh_address,
          isJy = data.isJy,
          levelstr = data.levelstr;
        setSubAccountNo(ischildno);
        // jyb开启 区县级 筛查管理权限
        setIsCheckOpen(ischeckopen);
        setSchoolId(school_id);
        setSchool(school);
        commit("SET_SCHOOL_ID", school_id);
        commit("SET_GRADE", grade);
        commit("SET_CLAZZ", clazz);
        commit("SET_SCHOOL", school);
        commit("SET_ROLES", roles);
        commit("SET_NAME", name);
        commit("SET_TELPHONE", telphone);
        commit("SET_AVATAR", avatar);
        commit("SET_INTRODUCTION", introduction);
        commit("SET_AREA_CODE", area_code);
        commit("SET_AREA_NAME", area_name);
        commit("SET_AREA_LEVEL", area_level);
        commit("SET_WHOLE_NAME", whole_name);
        commit("SET_LOGINTIME", logintime);
        commit("SET_USERNAME", username);
        commit("SET_ISCHILDNO", ischildno);
        commit("SET_ADDRESS", address);
        commit("SET_ISCUSTOMRECEIPT", iscustomreceipt);
        commit("SET_ISSECRET", issecret);
        commit("SET_ISCONFIG", isconfig);
        commit("SET_IS_PASSWORD_OLD", is_password_old);
        commit("SET_IS_CHECKDATA", is_checkdata);
        commit("SET_IS_CHECKOPEN", ischeckopen);
        commit("SET_GRADE_CODE", grade_code);
        commit("SET_IS_JS", isJs);
        commit("SET_IS_ANHUI", isAnhui);
        commit("SET_USER_NAME", user_name);
        commit("SET_NICKNAME", nickname);
        commit("SET_REMARK", remark);
        commit("SET_DH_ADDRESS", dh_address);
        commit("SET_ISJY", isJy);
        commit("SET_LEVELSTR", levelstr);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        // if (process.env.VUE_APP_MODE != 'xm' && process.env.VUE_APP_MODE != 'hb') {
        //   this.$socket.close()
        // }
        localStorage.setItem("socketid", "");
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_USERNAME", "");
        removeToken();
        removeSchoolId();
        removeSubAccountNo();
        removeIsCheckOpen();
        removeRoles();
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      // if (process.env.VUE_APP_MODE != 'xm' && process.env.VUE_APP_MODE != 'hb') {
      //   this.$socket.close()
      // }
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },
  // Dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + "-token";
              commit("SET_TOKEN", token);
              setToken(token);
              _context.next = 5;
              return dispatch("getInfo");
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch("permission/generateRoutes", roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);
              resolve();
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  },
  // 更新消息数量
  updateMsgNumber: function updateMsgNumber(_ref8) {
    var commit = _ref8.commit,
      state = _ref8.state;
    getInformationReminder({
      token: state.token
    }).then(function (res) {
      if (res.error == -1) {
        commit("SET_MSGNUM", res.data);
      }
    }).catch(function (error) {
      reject(error);
    });
  },
  // 更新未回复客服数量
  updateCustomerNumber: function updateCustomerNumber(_ref9) {
    var commit = _ref9.commit,
      state = _ref9.state;
    getConversationList({
      token: state.token,
      curPage: 1,
      reply_status: 0,
      pageSize: 10
    }).then(function (res) {
      if (res.error == -1) {
        // totalNum
        commit("SET_CUSTOMERNUM", res.data.totalNum);
      } else {
        commit("SET_CUSTOMERNUM", 0);
      }
    }).catch(function (error) {
      reject(error);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};